module.exports = __webpack_public_path__ + "static/img/NSW-16.7da77cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-16.jpg
// module id = Qb+1
// module chunks = 0